import React, { Component } from "react";
import { FileIcon, defaultStyles } from "react-file-icon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import GetBlob from "../../utils/get_blob";
const FILE_TYPE = "static_file";
/**
 * <File file={}
 *   tzOpts={}
 *   handleOpenContextMenu={}
 *   editMode={}
 * />
 * file value:
 *   {
 *     url,
 *     name,
 *     blob: {content_type, extension},
 *     activity: {method, user, timestamp},
 *   }
 **/
const File = (props) => {
  const { editMode, file, tzOpts, handleOpenContextMenu } = props;
  const { url, blob, name } = file;
  const { method, user, timestamp } = file.activity;
  const localeTimeStamp = new Date(timestamp).toLocaleString("en-US", tzOpts);
  const contextMenuBtn = (
    <button
      className="btn alert-secondary"
      type="button"
      onClick={(event) => {
        handleOpenContextMenu(file.id, FILE_TYPE, file.name, url, event);
      }}
    >
      <FontAwesomeIcon icon={faEllipsisV} color="grey" size="lg" />
    </button>
  );

  return (
    <a href={url} className="text-decoration-none">
      <li
        className="list-group-item d-flex justify-content-between"
        onContextMenu={(event) => {
          handleOpenContextMenu(file.id, FILE_TYPE, file.name, url, event);
        }}
      >
        <div className="file-name inner-buffer">
          <div className="d-flex justify-content-left">
            <div className="mr-2" style={{ maxWidth: "20px" }}>
              <FileIcon
                extension={blob["extension"]}
                {...defaultStyles[blob["extension"]]}
              />
            </div>
            <strong>{name}</strong>
          </div>
        </div>
        <div
          className="file-content-type inner-buffer text-muted"
          title="file content type"
        >
          {blob["content_type"]}
        </div>
        <div className="file-timestamp inner-buffer text-muted">
          {method} by {user} <em>({localeTimeStamp})</em>
        </div>
        {contextMenuBtn}
      </li>
    </a>
  );
};

export default File;
